import React, { memo, useCallback, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import { Snackbar } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

const useStyles = makeStyles((theme) => ({
  top: {
    top: theme.spacing(8),
  },
}));

const Toast = (props) => {
  const { msg, severity, toastRef, open, ...rest } = props;
  const classes = useStyles();
  const [isOpen, setOpen] = React.useState(open || false);

  const handleClick = useCallback(() => {
    setOpen(true);
  }, []);
  const handleClose = useCallback((event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }, []);

  useImperativeHandle(toastRef, () => ({
    open,
    setOpen,
    on: handleClick,
    off: handleClose,
  }));

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      className={classes.top}
      {...rest}
    >
      <Alert
        onClose={handleClose}
        severity={severity || "warning"}
      >
        {msg}
      </Alert>
    </Snackbar>
  );
}
Toast.prototypes = {
  severity: PropTypes.string,
}
export default memo(Toast);
